import { Link } from "react-router-dom";
import { AdminPanel } from "../../components/admin/AdminPanel";
import { Badge } from "../../components/ui/Badge";
import { Button } from "../../components/ui/Button";
import { EmptyState } from "../../components/ui/EmptyState";
import { useTenant } from "../../hooks/useTenant";
import { formatDateTime, statusTone } from "../../lib/format";

export function TrainerHomePage() {
  const { currentTenant, currentRole } = useTenant();

  if (!currentTenant) {
    return <EmptyState title="No workspace selected." />;
  }

  return (
    <div>
      <p className="eyebrow">Trainer workspace</p>
      <div className="mt-3 flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
        <div>
          <h1 className="text-3xl font-semibold text-ink">{currentTenant.name}</h1>
          <p className="mt-3 max-w-2xl text-base leading-7 text-graphite/70">
            Manage the workspace identity, team visibility and client profile foundation.
          </p>
        </div>
        <div className="flex gap-2">
          <Link to="/trainer/clients/new"><Button>Invite client</Button></Link>
          <Link to="/trainer/business"><Button variant="secondary">Business profile</Button></Link>
        </div>
      </div>

      <div className="mt-8 grid gap-5 lg:grid-cols-3">
        <AdminPanel title="Workspace status">
          <Badge tone={statusTone(currentTenant.status)}>{currentTenant.status}</Badge>
          <p className="mt-4 text-sm text-graphite/70">Plan: {currentTenant.plan}</p>
          <p className="mt-2 text-sm text-graphite/70">
            Trial expiry: {formatDateTime(currentTenant.trial_expires_at)}
          </p>
        </AdminPanel>
        <AdminPanel title="Your access">
          <p className="text-2xl font-semibold text-ink">{currentRole}</p>
          <p className="mt-2 text-sm leading-6 text-graphite/70">
            Role changes are controlled by platform administration at this stage.
          </p>
        </AdminPanel>
        <AdminPanel title="Next modules">
          <p className="text-sm leading-6 text-graphite/70">
            Workout plans, check-ins, progress, nutrition and messages are placeholders only until the next product layer.
          </p>
        </AdminPanel>
      </div>
    </div>
  );
}
